import { useDispatch, useSelector } from "react-redux"
import { ChangePercentCity } from "../../Reducer/RevenueSlice"
import { useState } from "react"


function PercentCityComponent(){
    const PercentCity = useSelector(state => state.RevenueSlice.PercentCity)

    const SelectedMonth = useSelector(state => state.MonthSlice.SelectedMonth)

    const [CancelTouch, setCancelTouch] = useState(false)
    
    const dispatch = useDispatch()

    return(
        <div
        className="PercentCityGlobalDiv"
        >
            <div
            className="PercentCityMainDiv"
            >
                <div
                className="RevenueCityLongDiv"
                >
                    {'% на кассиров'}
                </div>
                <input
                type="Number"
                className="PercentCityInput"
                id={'PercentCityInputKashier'}
                value={PercentCity.Kashier}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(() => {
                    if(!CancelTouch)
                        document.getElementById('PercentCityInputKashier').focus()
                })}
                onFocus={(() =>{
                    document.getElementById('PercentCityInputKashier').classList.add('Selected')
                })}
                onBlur={(() => {
                    document.getElementById('PercentCityInputKashier').classList.remove('Selected')
                })}
                onChange={((e) => {
                    if(SelectedMonth.BlockEdit !== true)  
                        if(e.target.value !== '' && e.target.value > -1)
                        {
                            dispatch(ChangePercentCity({Type: 'Kashier', Value: parseFloat(e.target.value)}))
                        }
                        else
                        {
                            dispatch(ChangePercentCity({Type: 'Kashier', Value: 0}))
                        }
                })}
                />
            </div>
            <div
            className="PercentCityMainDiv"
            >
                <div
                className="RevenueCityLongDiv"
                >
                    {'% на поваров (группа 1)'}
                </div>
                <input
                type="Number"
                className="PercentCityInput"
                id={'PercentCityInputCook'}
                value={PercentCity.Cook}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(() => {
                    if(!CancelTouch)
                        document.getElementById('PercentCityInputCook').focus()
                })}
                onFocus={(() =>{
                    document.getElementById('PercentCityInputCook').classList.add('Selected')
                })}
                onBlur={(() => {
                    document.getElementById('PercentCityInputCook').classList.remove('Selected')
                })}
                onChange={((e) => {
                    if(SelectedMonth.BlockEdit !== true) 
                        if(e.target.value !== '' && e.target.value > -1)
                        {
                            dispatch(ChangePercentCity({Type: 'Cook', Value: parseFloat(e.target.value)}))
                        }
                        else
                        {
                            dispatch(ChangePercentCity({Type: 'Cook', Value: 0}))
                        }
                })}
                />
            </div>

            <div
            className="PercentCityMainDiv"
            >
                <div
                className="RevenueCityLongDiv"
                >
                    {'% на поваров (группа 2)'}
                </div>
                <input
                type="Number"
                className="PercentCityInput"
                id={'PercentCityInputCookSecondGroup'}
                value={PercentCity.CookSecondGroup}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(() => {
                    if(!CancelTouch)
                        document.getElementById('PercentCityInputCookSecondGroup').focus()
                })}
                onFocus={(() =>{
                    document.getElementById('PercentCityInputCookSecondGroup').classList.add('Selected')
                })}
                onBlur={(() => {
                    document.getElementById('PercentCityInputCookSecondGroup').classList.remove('Selected')
                })}
                onChange={((e) => {
                    if(SelectedMonth.BlockEdit !== true) 
                        if(e.target.value !== '' && e.target.value > -1)
                        {
                            dispatch(ChangePercentCity({Type: 'CookSecondGroup', Value: parseFloat(e.target.value)}))
                        }
                        else
                        {
                            dispatch(ChangePercentCity({Type: 'CookSecondGroup', Value: 0}))
                        }
                })}
                />
            </div>

            <div
            className="PercentCityMainDiv"
            >
                <div
                className="RevenueCityLongDiv"
                >
                    {'Сумма выручки для премирования'}
                </div>
                <input
                type="Number"
                className="PercentCityInput"
                id={'PercentCityInputMinSum'}
                value={PercentCity.PrizeMinSum}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(() => {
                    if(!CancelTouch)
                        document.getElementById('PercentCityInputMinSum').focus()
                })}
                onFocus={(() =>{
                    document.getElementById('PercentCityInputMinSum').classList.add('Selected')
                })}
                onBlur={(() => {
                    document.getElementById('PercentCityInputMinSum').classList.remove('Selected')
                })}
                onChange={((e) => {
                    if(SelectedMonth.BlockEdit !== true) 
                        if(e.target.value !== '' && e.target.value > -1)
                        {
                            dispatch(ChangePercentCity({Type: 'PrizeMinSum', Value: parseFloat(e.target.value)}))
                        }
                        else
                        {
                            dispatch(ChangePercentCity({Type: 'PrizeMinSum', Value: 0}))
                        }
                })}
                />
            </div>
            <div
            className="PercentCityMainDiv"
            >
                <div
                className="RevenueCityLongDiv"
                >
                    {'Премия кассиров от выручки'}
                </div>
                <input
                type="Number"
                className="PercentCityInput"
                id={'PercentCityInputPrizeSumKashier'}
                value={PercentCity.PrizeSumKashier}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(() => {
                    if(!CancelTouch)
                        document.getElementById('PercentCityInputPrizeSumKashier').focus()
                })}
                onFocus={(() =>{
                    document.getElementById('PercentCityInputPrizeSumKashier').classList.add('Selected')
                })}
                onBlur={(() => {
                    document.getElementById('PercentCityInputPrizeSumKashier').classList.remove('Selected')
                })}
                onChange={((e) => {
                    if(SelectedMonth.BlockEdit !== true) 
                        if(e.target.value !== '' && e.target.value > -1)
                        {
                            dispatch(ChangePercentCity({Type: 'PrizeSumKashier', Value: parseFloat(e.target.value)}))
                        }
                        else
                        {
                            dispatch(ChangePercentCity({Type: 'PrizeSumKashier', Value: 0}))
                        }
                })}
                />
            </div>
            <div
            className="PercentCityMainDiv"
            >
                <div
                className="RevenueCityLongDiv"
                >
                    {'Премия поваров (группа 1) от выручки'}
                </div>
                <input
                type="Number"
                className="PercentCityInput"
                id={'PercentCityInputPrizeSumCook'}
                value={PercentCity.PrizeSumCook}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(() => {
                    if(!CancelTouch)
                        document.getElementById('PercentCityInputPrizeSumCook').focus()
                })}
                onFocus={(() =>{
                    document.getElementById('PercentCityInputPrizeSumCook').classList.add('Selected')
                })}
                onBlur={(() => {
                    document.getElementById('PercentCityInputPrizeSumCook').classList.remove('Selected')
                })}
                onChange={((e) => {
                    if(SelectedMonth.BlockEdit !== true) 
                        if(e.target.value !== '' && e.target.value > -1)
                        {
                            dispatch(ChangePercentCity({Type: 'PrizeSumCook', Value: parseFloat(e.target.value)}))
                        }
                        else
                        {
                            dispatch(ChangePercentCity({Type: 'PrizeSumCook', Value: 0}))
                        }
                })}
                />
            </div>
            <div
            className="PercentCityMainDiv"
            >
                <div
                className="RevenueCityLongDiv"
                >
                    {'Премия поваров (группа 2) от выручки'}
                </div>
                <input
                type="Number"
                className="PercentCityInput"
                id={'PercentCityInputPrizeSumCookSecondGroup'}
                value={PercentCity.PrizeSumCookSecondGroup || 0}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(() => {
                    if(!CancelTouch)
                        document.getElementById('PercentCityInputPrizeSumCookSecondGroup').focus()
                })}
                onFocus={(() =>{
                    document.getElementById('PercentCityInputPrizeSumCookSecondGroup').classList.add('Selected')
                })}
                onBlur={(() => {
                    document.getElementById('PercentCityInputPrizeSumCookSecondGroup').classList.remove('Selected')
                })}
                onChange={((e) => {
                    if(SelectedMonth.BlockEdit !== true) 
                        if(e.target.value !== '' && e.target.value > -1)
                        {
                            dispatch(ChangePercentCity({Type: 'PrizeSumCookSecondGroup', Value: parseFloat(e.target.value)}))
                        }
                        else
                        {
                            dispatch(ChangePercentCity({Type: 'PrizeSumCookSecondGroup', Value: 0}))
                        }
                })}
                />
            </div>
            <div
            className="PercentCityMainDiv"
            >
                <div
                className="RevenueCityLongDiv"
                >
                    {'Коэффициент выручки %'}
                </div>
                <input
                type="Number"
                className="PercentCityInput"
                id={'PercentCityInputRatioRevenue'}
                value={PercentCity.RatioRevenue}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(() => {
                    if(!CancelTouch)
                        document.getElementById('PercentCityInputRatioRevenue').focus()
                })}
                onFocus={(() =>{
                    document.getElementById('PercentCityInputRatioRevenue').classList.add('Selected')
                })}
                onBlur={(() => {
                    document.getElementById('PercentCityInputRatioRevenue').classList.remove('Selected')
                })}
                onChange={((e) => {
                    if(SelectedMonth.BlockEdit !== true) 
                        if(e.target.value !== '' && e.target.value > -1)
                        {
                            dispatch(ChangePercentCity({Type: 'RatioRevenue', Value: parseFloat(e.target.value)}))
                        }
                        else
                        {
                            dispatch(ChangePercentCity({Type: 'RatioRevenue', Value: 0}))
                        }
                })}
                />
            </div>
        </div>
    )
}

export default PercentCityComponent